/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
export const MODEL_HEADER = {
    zone: null,
    date: new Date()
}


export const CARDS_MODEL = {
    PENDING_TO_COMPLETE : 'pendingToComplete',
    PENDING_VALIDATION : 'pendingValidation',
    READY_TO_ENTER : 'readyToEnter',
    CHECKED_IN : 'checkIn'
}


export const DEFAULT_ZONE_PATH = "ALL";

export const TIME_STATUS = {
    OVERDUE: {chip :'chip-error-code-150-100', icon : 'icon-color-error-code-700'},
    DUE_SOON: {chip :'chip-warning-150-100', icon : 'icon-color-warning-700'},
    UPCOMING: {chip :'chip-secondary-150-100', icon : 'icon-color-secondary-700'},
    ON_TIME: {chip :'chip-success-150-100', icon : 'icon-color-success-700'},
    PASSED: {chip :'chip-shades-150-200', icon : 'icon-color-shades-700'},
};
